import { render } from "./BaseFnbHeaderNav.vue?vue&type=template&id=a5e4b0c6&scoped=true"
import script from "./BaseFnbHeaderNav.vue?vue&type=script&lang=js"
export * from "./BaseFnbHeaderNav.vue?vue&type=script&lang=js"

import "./BaseFnbHeaderNav.vue?vue&type=style&index=0&id=a5e4b0c6&scoped=true&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5e4b0c6"]])

export default __exports__